// extracted by mini-css-extract-plugin
export default {"logo":"_cb865789"};